import React, { useState, useEffect } from "react";
import { useNotifications } from "./Dashboard/hooks/useNotifications";

const departments = [
    { "name": "परिचय ", "id": "aboutLibrary" },
    { "name": "पुस्तकालय नियमावली", "id": "libraryRules" },
    { "name": "पुस्तकालय समिति", "id": "libraryCommittee" },
    { "name": "ई-सेवाएं (महर्षि प्रभा)", "id": "eServices" },
    { "name": "मासिक/षाण्मासिक पत्रिकाएं/समाचार पत्र", "id": "periodicalsNews" },
    { "name": "विश्वविद्यालय द्वारा प्रकाशित पुस्तकें", "id": "publishedBooks" },
    { "name": "छात्रों के लिए सुविधाएं", "id": "studentFacilities" },
    { "name": "प्रपत्र (फार्म)", "id": "forms" },
    { "name": "फोटो गैलरी", "id": "photoGallery" },
    { "name": "सम्पर्क", "id": "contact" }
];

// सिर्फ इन दोनों के लिए location map
const locationMap = {
    eServices: "universityNewspaper",
    publishedBooks: "publications"
};

export default function Library() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeContentId, setActiveContentId] = useState("aboutLibrary");
    const [location, setLocation] = useState("");

    useEffect(() => {
        const handleResize = () => {
            setShowSidebar(window.innerWidth >= 768);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (locationMap[activeContentId]) {
            setLocation(locationMap[activeContentId]);
        } else {
            setLocation("");
        }
    }, [activeContentId]);

    const handleItemClick = (deptId) => {
        setActiveContentId(deptId);
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    const { notifications, loading, handleNotificationClick } = useNotifications(location);

    const renderPDFSection = () => {
        return loading ? (
            <p>लोड हो रहा है...</p>
        ) : notifications?.length > 0 ? (
            <table className="table table-bordered small">
                <thead className="table-secondary">
                    <tr>
                        <th>शीर्षक</th>
                        <th>डाउनलोड</th>
                    </tr>
                </thead>
                <tbody>
                    {notifications.map((file, index) => (
                        <tr key={index}>
                            <td>{file.title_Hindi}</td>
                            <td>
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => handleNotificationClick(file)}
                                >
                                    डाउनलोड करें
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        ) : (
            <p className="text-muted">कोई पीडीएफ उपलब्ध नहीं है।</p>
        );
    };

    const departmentContent = {
        aboutLibrary: (
            <div>
                <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>
                    पुस्तकालय का परिचय
                </h5>
                <p className="text-muted text-justify">
                    विश्वविद्यालय का पुस्तकालय ज्ञान का केंद्र है। यहाँ विभिन्न विषयों पर पुस्तकें, शोध पत्रिकाएँ और संदर्भ सामग्री उपलब्ध हैं। पुस्तकालय छात्रों, शिक्षकों और शोधकर्ताओं को अध्ययन और अनुसंधान के लिए एक शांत और प्रेरक वातावरण प्रदान करता है।
                </p>
            </div>
        ),
        libraryRules: (
            <div>
                <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>
                    पुस्तकालय नियमावली
                </h5>
                <p className="text-muted text-justify">पुस्तकालय के नियम और विनियम जल्द ही उपलब्ध कराए जाएंगे।</p>
            </div>
        ),
        libraryCommittee: (
            <div>
                <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>
                    पुस्तकालय समिति
                </h5>
                <div className="table-responsive">
                    <table className="table table-bordered table-striped small">
                        <thead className="table-dark">
                            <tr>
                                <th>क्र.</th>
                                <th>नाम</th>
                                <th>पद</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>अधिष्ठाता शैक्षणिक, म.वा.सं.वि., कैथल।</td>
                                <td>अध्यक्ष</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>डॉ. जगत नारायण कौशिक, विभागाध्यक्ष (साहित्य)।</td>
                                <td>सह-अध्यक्ष</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>डॉ. सुरेन्द्र पाल वत्स, विभागाध्यक्ष (व्याकरण)।</td>
                                <td>सदस्य</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>डॉ. नरेश शर्मा, विभागाध्यक्ष (ज्योतिष), म.वा.सं.वि., कैथल।</td>
                                <td>सदस्य</td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>डॉ. अखिलेश कुमार मिश्र, विभागाध्यक्ष (वेद), म.वा.सं.वि., कैथल।</td>
                                <td>सदस्य</td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>डॉ. कृष्ण चन्द्र पाण्डे, विभागाध्यक्ष (हिन्दू अध्ययन), म.वा.सं.वि., कैथल।</td>
                                <td>सदस्य</td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>डॉ. देवेन्द्र सिंह, प्रभारी (योग), म.वा.सं.वि., कैथल।</td>
                                <td>सदस्य</td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>डॉ. विनय गोपाल त्रिपाठी, प्रभारी (दर्शन),, म.वा.सं.वि., कैथल।</td>
                                <td>सदस्य</td>
                            </tr>
                            <tr>
                                <td>9</td>
                                <td>डॉ. कुलदीप सिंह, प्रभारी (धर्मशास्त्र), म.वा.सं.वि., कैथल।</td>
                                <td>सदस्य</td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>श्री कुलवन्त सिंह, लिपिक (HKRN), म.वा.सं.वि., कैथल।</td>
                                <td>सदस्य</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        ),
        eServices: (
            <div>
                <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>
                    ई-सेवाएं (महर्षि प्रभा)
                </h5>
                {renderPDFSection()}
            </div>
        ),
        periodicalsNews: (
            <div>
                <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>
                    मासिक/षाण्मासिक पत्रिकाएं/समाचार पत्र
                </h5>
                <p className="text-muted text-justify">
                    पुस्तकालय में उपलब्ध मासिक और षाण्मासिक पत्रिकाओं और समाचार पत्रों की सूची जल्द ही अपडेट की जाएगी।
                </p>
            </div>
        ),
        publishedBooks: (
            <div>
                <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>
                    विश्वविद्यालय द्वारा प्रकाशित पुस्तकें
                </h5>
                {renderPDFSection()}
            </div>
        ),
        studentFacilities: (
            <div>
                <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>
                    छात्रों के लिए सुविधाएं
                </h5>
                <p className="text-muted text-justify">
                    छात्रों के लिए पुस्तकालय में उपलब्ध विभिन्न सुविधाओं का विवरण जल्द ही प्रदान किया जाएगा।
                </p>
            </div>
        ),
        forms: (
            <div>
                <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>
                    प्रपत्र (फार्म)
                </h5>
                <p className="text-muted text-justify">आवश्यक प्रपत्रों (फार्म) की सूची जल्द ही प्रदान की जाएगी।</p>
            </div>
        ),
        photoGallery: (
            <div>
                <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>
                    फोटो गैलरी
                </h5>
                <p className="text-muted text-justify">पुस्तकालय की फोटो गैलरी जल्द ही उपलब्ध होगी।</p>
            </div>
        ),
        contact: (
            <div>
                <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>
                    सम्पर्क
                </h5>
                <p className="text-muted text-justify">पुस्तकालय से संपर्क करने की जानकारी जल्द ही उपलब्ध कराई जाएगी।</p>
            </div>
        )
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{ backgroundColor: "#77236b", borderColor: "#77236b" }}
            >
                ☰ मेनू
            </button>

            <aside
                className={`p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"
                    } col-md-3`}
                style={{ backgroundColor: "#f8f9fa", overflowY: "auto" }}
            >
                <h5 className="text-center fw-bold mb-3 text-dark">पुस्तकालय</h5>
                <div className="flex-grow-1">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className={`mb-2 p-2 rounded shadow-sm small transition-all ${activeContentId === dept.id
                                ? "text-white fw-bold"
                                : "bg-white text-dark hover-effect"
                                }`}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeContentId === dept.id ? "#77236b" : undefined
                            }}
                            onClick={() => handleItemClick(dept.id)}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto"
                onClick={() => {
                    if (window.innerWidth < 768 && showSidebar) {
                        setShowSidebar(false);
                    }
                }}
            >
                {departmentContent[activeContentId] || (
                    <p className="text-muted">कृपया किसी अनुभाग का चयन करें।</p>
                )}
            </main>
        </div>
    );
}
